import styled from '@emotion/styled'
import { AspectRatio } from 'components/AspectRatio'
import { Text } from 'components/Typography'
import { pxToRem } from 'utils/styled'

export const SChooseAnimationModal = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const SHeading = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${pxToRem(24)}rem;
`

export const STitle = styled(Text)`
  color: black;
  font-weight: bold;
  font-size: ${pxToRem(21)}rem;
  margin-left: ${pxToRem(12)}rem;
`

export const SText = styled(Text)`
  margin-bottom: ${pxToRem(24)}rem;
`

export const SGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 1.5rem;
`

export const SColumn = styled.div`
  display: flex;
  flex-direction: column;
  & > label {
    margin: 0.4rem 0 0.8rem;
    & > p {
      color: black;
      font-weight: bold;
    }
  }
`

export const SAspectRatio = styled(AspectRatio)`
  & > div,
  > div > div,
  video {
    width: 100%;
    object-fit: cover;
  }
`
